import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = { auth: authRoles.admin, routes: [{ path: '/pickup-stats', component: FuseLoadable({ loader: () => import('./PickupStatsApp') }) }] };

export default [Index];
